import type { ResolvedStorageKeys } from '../constants/storageKeys';

export interface KeyedTokenSet {
  accessToken: string | null;
  idToken: string | null;
  refreshToken: string | null;
}

export const getKeyedTokens = (keys: ResolvedStorageKeys): KeyedTokenSet => ({
  accessToken: localStorage.getItem(keys.accessTokenKey),
  idToken: localStorage.getItem(keys.idTokenKey),
  refreshToken: localStorage.getItem(keys.refreshTokenKey),
});

export const setKeyedTokens = (
  keys: ResolvedStorageKeys,
  accessToken: string,
  idToken: string
) => {
  localStorage.setItem(keys.accessTokenKey, accessToken);
  localStorage.setItem(keys.idTokenKey, idToken);
};

export const setKeyedRefreshToken = (
  keys: ResolvedStorageKeys,
  refreshToken: string
) => {
  localStorage.setItem(keys.refreshTokenKey, refreshToken);
};
